const produtos = [
  { text: 'Ac. Premium', value: 0, color: '#CBA135', tipo: 0, order: 1 },
  { text: 'FitHit', value: 1, color: 'secondary', tipo: 0, order: 9 },
  { text: 'Fight Kids', value: 2, color: 'success', tipo: 0, order: 10 },
  { text: 'Pilates', value: 3, color: 'warning', tipo: 0, order: 6 },
  { text: 'Lets Run', value: 4, color: '#FF3C38', tipo: 0, order: 7 },
  { text: 'U. Nova Mulher', value: 5, color: '#E91E63', tipo: 0, order: 5 },
  { text: 'Ac. Lite', value: 6, color: '#64B5F6', tipo: 0, order: 2 },
  { text: 'Ac. Flex', value: 7, color: '#4DB6AC', tipo: 1, order: 3 },
  { text: 'Mindfulness', value: 8, color: '#81C784', tipo: 0, order: 4 },
  { text: 'Lets One', value: 9, color: '#283593', tipo: 0, order: 8 },
  { text: 'Habitus', value: 10, color: '#505472ff', tipo: 0, order: 10 },
  { text: 'Roma', value: 11, color: '#7f359dff', tipo: 0, order: 11 },
  { text: 'Lets Sports', value: 12, color: '#237962ff', tipo: 0, order: 12 },
];
// const produtosOrdenados = [...produtos].sort((a, b) => a.order - b.order);

// export default produtosOrdenados;
export default produtos;
